import { render, staticRenderFns } from "./footerMobile.vue?vue&type=template&id=3e39b9d9&scoped=true&"
import script from "./footerMobile.vue?vue&type=script&lang=js&"
export * from "./footerMobile.vue?vue&type=script&lang=js&"
import style0 from "./footerMobile.vue?vue&type=style&index=0&id=3e39b9d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e39b9d9",
  null
  
)

export default component.exports